import {Deck, WebMercatorViewport} from '@deck.gl/core';
import {GeoJsonLayer} from '@deck.gl/layers';
import * as d3 from 'd3';
import getScenes from './story';
import * as PROPS from './props';

import { fitBounds } from './props';
import { createText } from './text';

import './index.css';

const DATA_URL = 'balesetek.json';
const SUN_DATA_URL = 'balesetek_napok.json';

const MAP_URL = '../balesetek/index.html';

document.body.style.fontSize = Math.max(14, (window.innerWidth + window.innerHeight) / 90) + 'px';

// =====================
// get lang parameter
// =====================
const params = new URLSearchParams(window.location.search);
const lang =  params.get('lang') === 'en' ? 'en' : 'hu';

// =====================
// set title, text, logo
// =====================
const text = createText(lang);
const title = text('title');
document.title = title;
d3.select('#title').text(title)
const logoURL = text('logo');
d3.select('#logoImg').attr('src', logoURL);

// =====================
// load data
// =====================
d3.select('#loading').text(text('loading'));

Promise.all([d3.json(DATA_URL), d3.json(SUN_DATA_URL)])
  .then(dataLoaded)
  .catch(error => console.log('Error', error));

function dataLoaded([data, sunData]) {
  // ======================
  const dateOfDay = day => new Date(2016, 0, day);
  const getSeason = d => [3, 3, 0, 0, 0, 1, 1, 1, 2, 2, 2, 3][d.getMonth()]; // starting from March
  const dayLabel = date => {
    const options = { month: 'long', day: 'numeric' };
    return date.toLocaleDateString("hu-HU", options);
  }
  const addCalendarProps = d => {
    const date = dateOfDay(d.key);
    d.month = date.getMonth();
    d.season = getSeason(date);
    d.dayLabel = dayLabel(date);
  }

  sunData.all.sunData.forEach(addCalendarProps);
  sunData.alcohol.sunData.forEach(addCalendarProps);

  // ======================
  let currentScene = 0;
  const geojson = new GeoJsonLayer({
    ...PROPS.GEO_JSON
  });

  let currentViewState = {
    ...PROPS.INITIAL_VIEW_STATE,
    ...fitBounds(window.innerWidth, window.innerHeight,
      PROPS.INITIAL_VIEW_STATE.nw, PROPS.INITIAL_VIEW_STATE.se)
  };

  const deck = new Deck({
    controller: true,
    viewState: currentViewState
  });

  const [scenes, sceneCount] = getScenes(deck, data, sunData, text);
  deck.setProps({
    // required callback
    onViewStateChange: ({viewState}) => {
      // you can manipulate the viewState here if needed
      deck.setProps({viewState});
      //log boundaries
      const viewport = new WebMercatorViewport(
        {
          width: window.innerWidth,
          height: window.innerHeight,
          ...viewState
        }
      );
      const nw = viewport.unproject([0, 0]);
      const se = viewport.unproject([window.innerWidth, window.innerHeight]);
      //console.log(nw, se, viewState.bearing, viewState.pitch);
      currentViewState = { ...viewState, nw, se };
    },
    onResize: ({width, height}) => {
      document.body.style.fontSize = Math.max(12, (width + height) / 100) + 'px';
      const {longitude, latitude, zoom} = fitBounds(window.innerWidth, window.innerHeight, currentViewState.nw, currentViewState.se);
      deck.setProps({
        viewState: { ...currentViewState, longitude, latitude, zoom}
      });
      currentViewState = { ...currentViewState, longitude, latitude, zoom};
      scene(currentScene);
    },
    layers: [geojson],
    onLoad: () => {
      d3.select('#loading').remove();
      d3.select('#content').style('display', 'block');
      scene(currentScene);
    }
  });

  function scene(n = 0) {
    scenes(n);
  }

  function nextScene() {
    if (currentScene === sceneCount - 1) {
      window.open(MAP_URL);
    }
    if (currentScene < sceneCount - 1 ) scene(++currentScene);
  }

  function previousScene() {
    if (currentScene > 0) scene(--currentScene);
  }

  // buttons
  d3.select('#footer')
    .append('button')
      .attr('id', 'info')
      .text(text('methodology'))
      .on('click', () => {
        d3.select('#modalText').style('display', 'block');
        d3.select('#modalTextContainer > .title').text(text('modalTextTitle'));
        d3.select('#modalTextContainer > .content').html(text('modalText'));
        d3.select('#modalTextButton').text(text('close'));
        d3.select('#modalTextButton').on('click', () => d3.select('#modalText').style('display', 'none'));
      });
  d3.select('#footer')
    .append('button')
        .attr('id', 'previousButton')
        .text(text('back'))
        .on('click', () => previousScene());
  d3.select('#footer')
    .append('button')
        .attr('id', 'forwardButton')
        .attr('class', 'sceneButton')
        .text(text('forward'))
        .on('click', () => nextScene());

//map help
  d3.select('body').append('div')
    .attr('id', 'mapHelp')
    .style('display', 'none')
    .text(text('mapHelp'));

  d3.select('#datasource')
    .text(text('datasource'));


} // end of dataLoaded
